import Repository from './Repository'

const action = 'push-msg-requests'

export default {
  pushMsgRequests(data) {
    return Repository.post(action, data)
  },
  getContactsGroup() {
    return Repository.get(`${action}/contacts-groups`)
  },
}
